import { Link } from "react-router-dom";
import FadeIn from "@/components/FadeIn";
import { IMG } from "@/data/images";

const SERVICES = [
  {
    icon: "🏠",
    title: "Construcție la Roșu",
    image: IMG.laRosu,
    alt: "Fundație și structură beton armat StructBuild",
    desc: "Realizăm faza de construcție brută conform proiectului tehnic aprobat, cu materiale de calitate și echipă proprie certificată.",
    include: [
      "Lucrări de terasament și fundație",
      "Structură din beton armat sau zidărie portantă",
      "Zidărie interioară și exterioară",
      "Planșee, scări, acoperiș (șarpantă sau terasă)",
      "Instalații sanitare și electrice la nivel brut",
      "Timp mediu execuție: 6–10 luni",
    ],
  },
  {
    icon: "🏡",
    title: "Construcție la Cheie",
    image: IMG.laCheie,
    alt: "Casă modernă finisată la cheie de StructBuild",
    desc: "Preluăm proiectul de la zero și predăm locuința complet finisată, gata de mobilat și mutat.",
    include: [
      "Tot ce include construcția la roșu",
      "Tencuieli, glet, vopsitorie",
      "Placări ceramice, parchet, ferestre și uși",
      "Instalații complete (electric, termic, sanitare, gaz)",
      "Finisaje exterioare",
      "Amenajare minimală curte și intrare",
      "Timp mediu execuție: 12–18 luni",
    ],
  },
  {
    icon: "🏘️",
    title: "Ansambluri Rezidențiale",
    image: IMG.ansambluri,
    alt: "Ansamblu rezidențial construit de StructBuild",
    desc: "Proiectăm și construim complexe de locuințe individuale sau colective pentru dezvoltatori imobiliari.",
    include: [
      "Studiu de fezabilitate și planificare urbanistică",
      "Construcție simultană a mai multor unități",
      "Infrastructură: drumuri de acces, rețele utilitare",
      "Spații verzi și zone comune",
      "Management complet de proiect",
      "Livrare în tranșe sau integral",
    ],
  },
  {
    icon: "🔨",
    title: "Renovări & Extinderi",
    image: IMG.renovari,
    alt: "Interior renovat de StructBuild Construct",
    desc: "Modernizăm locuințe existente sau extindem suprafața utilă păstrând structura de rezistență.",
    include: [
      "Evaluare structurală inițială gratuită",
      "Extindere la parter sau mansardare",
      "Recompartimentare interioară",
      "Refacere completă instalații",
      "Izolație termică și fonică",
      "Finisaje complete la alegerea clientului",
    ],
  },
];

export default function Servicii() {
  return (
    <div data-testid="servicii-page">
      <header className="sb-page-header">
        <div className="sb-container">
          <h1>Serviciile Noastre</h1>
          <p>Construcție rezidențială de calitate, de la fundație până la cheie</p>
        </div>
      </header>

      <section className="sb-section">
        <div className="sb-container">
          <FadeIn className="sb-services-intro">
            StructBuild Construct oferă soluții complete pentru construcția și renovarea
            locuințelor rezidențiale. Fiecare proiect este tratat cu aceeași seriozitate,
            indiferent de dimensiune.
          </FadeIn>

          <div>
            {SERVICES.map((s, i) => (
              <FadeIn key={s.title} delay={i * 60}>
                <article className="sb-service-detail" data-testid={`service-detail-${i}`}>
                  <div className="sb-service-detail-content">
                    <h2>
                      <span aria-hidden="true">{s.icon}</span> {s.title}
                    </h2>
                    <p style={{ color: "var(--sb-body-gray)", lineHeight: 1.7 }}>{s.desc}</p>
                    <div className="sb-uppercase-label" style={{ marginTop: "1.4rem" }}>Include</div>
                    <ul className="sb-include-list">
                      {s.include.map((it) => (
                        <li key={it}>{it}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="sb-service-detail-image">
                    <img
                      src={s.image}
                      alt={s.alt}
                      className="sb-img-cover"
                      width="600"
                      height="400"
                      loading="lazy"
                    />
                  </div>
                </article>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <section className="sb-cta-banner" data-testid="servicii-cta">
        <FadeIn>
          <h2>Consultație Gratuită pentru Proiectul Tău</h2>
          <p>
            Fiecare proiect începe cu o consultație gratuită. Suntem alături de tine de la prima
            schiță până la predarea cheilor.
          </p>
          <Link to="/contact" className="sb-btn sb-btn-primary" data-testid="servicii-cta-btn">
            Solicită Consultație Gratuită <span aria-hidden="true">→</span>
          </Link>
        </FadeIn>
      </section>
    </div>
  );
}
